import React from "react";
import styled from "styled-components";
import { read_timeline_iso_date } from "../../../utils/timeline/timeline_normalization";
import { Timeline_Legacy_Activity_Text } from "./Timeline_Legacy_Activity_Text";
import { Timeline_Legacy_Activity_Changes } from "./Timeline_Legacy_Activity_Changes";
import { Timeline_Legacy_Activity_Schedule } from "./Timeline_Legacy_Activity_Schedule";
import {
    legacyActivityDateOptions,
    legacyActivityTimeOptions,
    read_legacy_activity_date
} from "./legacy_activity_formatting";

const TimelineLegacyActivity = styled.section`
    display: grid;
    min-width: 0;
    overflow: hidden;
    border: 0.1rem solid ${p => p.theme.mid};
    border-radius: var(--smallRadius);
    background: ${p => p.theme.background};
    font-family: "fontMedium", sans-serif;
`;

const TimelineLegacyHeader = styled.header`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.6rem 1.2rem;
    padding: 1rem;
    color: ${p => p.theme.color};

    h4 {
        min-width: 0;
        margin: 0;
        color: inherit;
        font-family: "fontBold", sans-serif;
        font-size: 1.35rem;
        font-weight: 400;
        overflow-wrap: anywhere;
    }

    time {
        color: inherit;
        font-size: 1.1rem;
    }
`;

const TimelineLegacyEvent = styled.div`
    display: grid;
    grid-template-columns: 4rem minmax(0, 1fr);
    align-items: baseline;
    gap: 0.6rem 0.8rem;
    min-width: 0;
    padding: 0.8rem 1rem;
    border-top: 0.1rem solid ${p => p.theme.low};

    @media (max-width: 480px) {
        grid-template-columns: minmax(0, 1fr);
        gap: 0.35rem;
    }
`;

const TimelineLegacyEventTime = styled.time`
    color: var(--greyDark);
    font-size: 1.05rem;
    overflow-wrap: anywhere;
`;

const TimelineLegacyEventContent = styled.div`
    display: grid;
    gap: 0.4rem;
    min-width: 0;
`;

// Shows one person's recorded history for one Athens calendar day, with every detail open.
export const Timeline_Legacy_Activity = (props) => {
    const day = props.event?.data?.day;
    const dayLabel = day ? read_legacy_activity_date(`${day}T12:00:00.000Z`, legacyActivityDateOptions) : "";
    const actor = props.event?.by?.name || props.t("Unknown author");
    const events = props.event?.data?.events || [];

    return (
        <TimelineLegacyActivity data-testid="timeline-legacy-activity" aria-label={props.t("Activity history")}>
            <TimelineLegacyHeader>
                <h4>{actor === "Unknown author" ? props.t(actor) : actor}</h4>
                <time dateTime={day || undefined}>{dayLabel || props.t("Date unavailable")}</time>
            </TimelineLegacyHeader>
            {events.map((event) => (
                <TimelineLegacyEvent key={event.id} data-testid={`timeline-legacy-${event.type.toLowerCase()}`}>
                    <TimelineLegacyEventTime dateTime={read_timeline_iso_date(event.at) || undefined}>
                        {read_legacy_activity_date(event.at, legacyActivityTimeOptions) || props.t("Time unavailable")}
                    </TimelineLegacyEventTime>
                    <TimelineLegacyEventContent>
                        {["MEETING", "CALLBACK"].includes(event.type) && <Timeline_Legacy_Activity_Schedule event={event} t={props.t} />}
                        <Timeline_Legacy_Activity_Text event={event} t={props.t} />
                        {Boolean(event.changes?.length) && <Timeline_Legacy_Activity_Changes event={event} t={props.t} />}
                    </TimelineLegacyEventContent>
                </TimelineLegacyEvent>
            ))}
        </TimelineLegacyActivity>
    );
};
